import type { DisciplineScheduleGridSlot } from './interfaces'

import { useDisciplineScheduleStore } from './schedule/store'
import {
  SCHEDULE_DAY_NAMES,
  isScheduleDaySelected,
  toggleScheduleDay,
} from './discipline-schedule'

interface DisciplineScheduleDayOptions {
  day: ComputedRef<string>
  slots: ComputedRef<DisciplineScheduleGridSlot[]>
}

interface DisciplineScheduleDayReturn {
  refName: ComputedRef<string>
  refIsSelected: ComputedRef<boolean>
  refIsAllSelected: ComputedRef<boolean>
  refHasSelectable: ComputedRef<boolean>
  refTooltip: ComputedRef<string>
  toggleDay: () => void
}

/** A day header picks every free hour of the day at once. */
export const useDisciplineScheduleDay = ({ day, slots }: DisciplineScheduleDayOptions): DisciplineScheduleDayReturn => {
  const store = useDisciplineScheduleStore()

  const refSelectable = computed<DisciplineScheduleGridSlot[]>(() => slots.value.filter(slot => !slot.disabled))

  const refName = computed<string>(() => SCHEDULE_DAY_NAMES[day.value] ?? day.value)
  const refIsSelected = computed<boolean>(() => store.getSelected.some(item => item.day === day.value))
  const refIsAllSelected = computed<boolean>(() => isScheduleDaySelected(store.getSelected, refSelectable.value))
  const refHasSelectable = computed<boolean>(() => refSelectable.value.length > 0)

  const refTooltip = computed<string>(() =>
    `${refIsAllSelected.value ? 'Unselect' : 'Select'} all ${refName.value} slots`)

  const toggleDay = (): void => {
    store.setSelected(toggleScheduleDay(store.getSelected, refSelectable.value))
  }

  return {
    refName,
    refIsSelected,
    refIsAllSelected,
    refHasSelectable,
    refTooltip,
    toggleDay,
  }
}
